import { ColorPickerForm } from "./ColorPickerForm";
import { Header } from "./Header";
import { PopperWrapper } from "./PopperWrapper";

interface ColorPickerFieldProps {
  colors: string[];
  onChange: (input: string) => void;
  subtitle: string;
  value: string;
}

export const ColorPickerField = ({
  value,
  subtitle,
  onChange,
  colors,
}: ColorPickerFieldProps) => (
  <PopperWrapper color={value}>
    <Header />
    <ColorPickerForm
      value={value}
      subtitle={subtitle}
      onChange={onChange}
      colors={colors}
    />
  </PopperWrapper>
);
